import styled, { css } from 'styled-components';

export const CardLayout = styled.div`
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
  gap: 20px;
`;

export const BottomButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px;
  > :last-child {
    min-width: ${({ buttonWidth = '100%' }) => buttonWidth};
  }
`;

export const BottomRightButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  padding: 10px;
  width: 100%;
`;

export const Message = styled.div`
  box-sizing: border-box;
  ${({ success }) => css`
    color: ${success ? 'green' : 'red'};
  `};
`;

export const CardBodyWrapper = styled.div`
  > div {
    margin: 3px 0px;
  }
`;
